import React, { useEffect, useState, useRef } from "react";
import {
  Form,
  Row,
  Col,
  Card,
  InputGroup,
  Modal,
  Button,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import delivaApiService from "../../../common/services/apiService";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../common/helpers/Utils";
import Header from "../commonAdmin/Header";
import Sidebar from "../commonAdmin/Sidebar";
import Loader from "../../common/Loader";
import Footer from "../commonAdmin/Footer";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { validation } from "./validation/validation";
import SharedDropdown from "../../common/SharedDropdown";
import moment from "moment";
import SharedCountryDropdown from "./SharedCountryDropdown";
import previewBg from "../../../assets/images/previewBg.svg";
import SealCheckRounded from "../../../assets/images/SealCheckRounded.svg";
import previewSenderBg from "../../../assets/images/previewSenderBg.svg";
import crossLight from "../../../assets/images/crossLight.svg";
import tooltip from "../../../assets/images/Info.png";

const initialFormData = {
  code: "",
  offerType: "PROMOTION",
  countOfUsageLimits: "",
  currency: "",
  deliveryDuration: "",
  deliveryDurationUnit: "DAYS",
  deliveryRequestType: "LOCAL_DELIVERY",
  description: "",
  discountApplicationType: null,
  geolocationBasedPromotions: "",
  imageUrl: "",
  maxDiscountAmount: null,
  minimumOrderAmount: null,
  noOfDelivery: "",
  occasions: null,
  offerName: "",
  otherOccasions: "",
  percentageDiscount: "",
  promoDiscountType: null,
  promotionEndDate: "",
  promotionEndTime: "",
  promotionStartDate: "",
  promotionStartTime: "",
  recurringPromotions: null,
  region: "",
  roleId: "",
  selectOccasions: null,
  stackableDiscounts: false,
  targetAudience: [""],
  usageFrequency: null,
  usageLimits: null,
  userCategory: null,
  senderType: "",
  discountType: "",
  discountAmount: "",
  discountApplication: "",
  stackableDiscountsEnabled: false,
  details: "",
  redeem: "",
};

// Utility: Combine local date and time, return UTC date and time strings using moment.js
function getUTCDateAndTimeFromLocal(localDateStr, localTimeStr) {
  if (!localDateStr || !localTimeStr) return { date: "", time: "" };
  // Combine date and time in local
  const localMoment = moment(
    `${localDateStr} ${localTimeStr}`,
    "YYYY-MM-DD HH:mm:ss",
  );
  // Convert to UTC
  const utcMoment = localMoment.utc();
  return {
    date: utcMoment.format("YYYY-MM-DD"),
    time: utcMoment.format("HH:mm:ss"),
  };
}

// Utility: Convert UTC date and time to local date and time strings using moment.js
function getLocalDateAndTimeFromUTC(utcDateStr, utcTimeStr) {
  if (!utcDateStr || !utcTimeStr) return { date: "", time: "" };
  const utcMoment = moment.utc(
    `${utcDateStr} ${utcTimeStr}`,
    "YYYY-MM-DD HH:mm:ss",
  );
  const localMoment = utcMoment.local();
  return {
    date: localMoment.format("YYYY-MM-DD"),
    time: localMoment.format("HH:mm:ss"),
  };
}

const CreatePromotion = (props) => {
  const { state } = useLocation();
  const { id, tab, isCopied } = state || {};
  const [editData, setEditData] = useState(null);
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [deleveryRequestType, setDeleveryRequestType] = useState([]);
  const [selectDiscountType, setSelectDiscountType] = useState([]);
  const [usageLimit, setUsageLimit] = useState([]);
  const [usageFrequency, setUsageFrequency] = useState([]);
  const [occation, setOccation] = useState([]);
  const [userCategory, setUserCategory] = useState([]);
  const [recPromotion, setRecPromotion] = useState([]);
  const [durationUnit, setDurationUnit] = useState([]);
  const [zipSuggestions, setZipSuggestions] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const history = useHistory();
  const [isZipValid, setIsZipValid] = useState(true);
  const [zipError, setZipError] = useState("");
  const [zipLoading, setZipLoading] = useState(false);
  const typingTimeoutRef = useRef(null);
  const [showPreview, setShowPreview] = useState(false);

  const handleCountryChange = async ({
    name,
    currency,
    currencySymbol,
    countryCode,
  }) => {
    setFormData((prev) => ({
      ...prev,
      region: name,
      currency,
      currencySymbol,
      countryCode,
    }));

    if (formData.geolocationBasedPromotions) {
      const result = await fetchPostalCodeInfo(
        formData.geolocationBasedPromotions,
        countryCode,
      );
      setIsZipValid(result.valid);
      setZipError(
        result.valid
          ? ""
          : "Please enter a valid ZIP code for the selected country.",
      );
    }
  };

  const fetchPostalCodeInfo = async (
    postalCode,
    overrideCountryCode = null,
  ) => {
    try {
      setZipLoading(true);

      const countryCode = overrideCountryCode || formData.countryCode;

      if (!countryCode) {
        setZipLoading(false);
        setZipError("Invalid country selected.");
        return { valid: false };
      }

      const apiKey = process.env.REACT_APP_API_KEY;
      const url = `https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:${postalCode}|country:${countryCode}&key=${apiKey}`;

      const response = await fetch(url);
      const data = await response.json();

      setZipLoading(false);

      if (data.status === "OK" && data.results.length > 0) {
        const components = data.results[0].address_components;
        const countryComponent = components.find((comp) =>
          comp.types.includes("country"),
        );

        const shortName = countryComponent?.short_name;

        return {
          valid: shortName === countryCode,
          country: countryComponent?.long_name,
          formatted: data.results[0].formatted_address,
          postalCode: postalCode,
        };
      }

      return { valid: false };
    } catch (error) {
      setZipLoading(false);
      return { valid: false };
    }
  };

  const handleZipInputChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setFormData((prev) => ({ ...prev, geolocationBasedPromotions: value }));
    setZipError("");
    setZipSuggestions([]);
    setIsZipValid(false); // assume invalid while typing

    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }

    typingTimeoutRef.current = setTimeout(async () => {
      if (value.length >= 1) {
        const result = await fetchPostalCodeInfo(value);

        if (result.formatted) {
          setZipSuggestions([
            {
              label: `${result.postalCode} - ${result.formatted}`,
              value: result.postalCode,
            },
          ]);
          setIsZipValid(result.valid);
          setZipError(
            result.valid
              ? ""
              : "Unverified zip code (might be partial or incorrect).",
          );
        } else {
          setIsZipValid(false);
          setZipSuggestions([]);
          setZipError(
            "Please enter a valid ZIP code for the selected country.",
          );
        }
      }
    }, 1000);
  };

  const handleZipSelectDropdown = (option) => {
    setFormData((prev) => ({
      ...prev,
      geolocationBasedPromotions: option.value,
    }));
    setZipSuggestions([]);
    setZipError("");
  };

  const enumSelectFields = [
    "senderType",
    "recurringPromotions",
    "usageLimits",
    "occasions",
    "deliveryDurationUnit",
    "discountType",
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => {
      let newValue;

      // Handle field value conversions
      if (type === "checkbox") {
        newValue = checked;
      } else if (type === "number") {
        newValue = Number(value);
      } else if (enumSelectFields.includes(name) && value === "") {
        newValue = null; // Treat empty string as null for enums
      } else {
        newValue = value;
      }

      let updatedFormData =
        name === "discountApplication" && value === "AUTOMATIC_APPLICATION"
          ? {
              ...prev,
              [name]:
                type === "checkbox"
                  ? checked
                  : type === "number"
                    ? Number(value)
                    : value,
              stackableDiscountsEnabled: false,
            }
          : {
              ...prev,
              [name]:
                type === "checkbox"
                  ? checked
                  : type === "number"
                    ? Number(value)
                    : value,
            };

      // Handle roleId specific logic
      if (name === "roleId") {
        const roleValue = value;

        // Auto-set discount type and amount based on role
        if (roleValue === "2") {
          updatedFormData.discountType = "FREE_DELIVERY";
          updatedFormData.discountAmount = "100";
        } else if (roleValue === "2") {
          updatedFormData.discountType = "PERCENTAGE_DISCOUNT";
          updatedFormData.discountAmount = "";
        } else if (roleValue === "3") {
          updatedFormData.discountType = "FIXED_AMOUNT";
          updatedFormData.discountAmount = "";
        } else {
          updatedFormData.discountType = "";
          updatedFormData.discountAmount = "";
        }

        // Set default deliveryRequestType if not set
        if (
          !updatedFormData.deliveryRequestType &&
          deleveryRequestType?.length > 0
        ) {
          updatedFormData.deliveryRequestType = deleveryRequestType[0].value;
        }

        // Set delivery duration values for roleId = 3
        if (roleValue === "3") {
          updatedFormData.deliveryDurationUnit = "DAYS";
        } else {
          updatedFormData.noOfDelivery = "";
          updatedFormData.deliveryDuration = "";
          updatedFormData.deliveryDurationUnit = null;
        }
      }

      // Handle discountType change
      if (name === "discountType") {
        if (value === "FREE_DELIVERY") {
          updatedFormData.discountAmount = "100";
          updatedFormData.maxDiscountAmount = "";
        } else if (value === "FIXED_AMOUNT") {
          updatedFormData.discountAmount = "";
          updatedFormData.maxDiscountAmount = "";
        }
      }

      if (name === "discountApplication") {
        if (value === "AUTOMATIC_APPLICATION") {
          updatedFormData.stackableDiscountsEnabled = false;
        }
      }

      console.log("Updated Form Data:", updatedFormData);
      return updatedFormData;
    });

    // Clear errors on input change
    setErrors((prevErrors) => {
      let errorFormData = {
        ...prevErrors,
        [name]: null,
      };

      if (name === "roleId") {
        if (value === "2") {
          errorFormData.discountType = null;
          errorFormData.discountAmount = null;
        }
        if (value === "3") {
          errorFormData.discountType = null;
          errorFormData.maxDiscountAmount = null;
        }
      }

      if (name === "discountType") {
        errorFormData.discountAmount = "";
      }

      if (name === "offerName") {
        const validationErrors = validation({ ...formData, offerName: value });
        setErrors((prevErrors) => ({
          ...prevErrors,
          offerName: validationErrors.offerName || null,
        }));
      }

      return errorFormData;
    });
  };

  const selectedDate = new Date();
  const isToday = selectedDate.toDateString() === new Date().toDateString();
  const minTime = isToday
    ? selectedDate
    : new Date(new Date().setHours(0, 0, 0, 0));

  // Set minTime for start time: if startDate is today, minTime is now; otherwise, midnight
  const isStartToday =
    startDate && startDate.toDateString() === new Date().toDateString();
  const minStartTime = isStartToday
    ? new Date()
    : new Date(new Date().setHours(0, 0, 0, 0));
  const isEndToday =
    endDate && endDate.toDateString() === new Date().toDateString();
  const isSameDay =
    startDate && endDate && startDate.toDateString() === endDate.toDateString();
  let minEndTime;
  if (isEndToday) {
    minEndTime = new Date();
  } else if (isSameDay && startTime) {
    minEndTime = startTime;
  } else {
    minEndTime = new Date(new Date().setHours(0, 0, 0, 0));
  }

  const handleDateChange = (name, value) => {
    const rawDate = new Date(value);
    const formattedDate = rawDate.toISOString().split("T")[0];
    setFormData((prev) => {
      let updatedFormData = {
        ...prev,
        [name]: null,
      };
      if (name === "promotionStartDate") {
        updatedFormData.promotionStartDate = formattedDate;
      }
      if (name === "promotionEndDate") {
        updatedFormData.promotionEndDate = formattedDate;
      }
      return updatedFormData;
    });
    setErrors((prevErrors) => {
      let errorFormData = {
        ...prevErrors,
        [name]: null,
      };
      return errorFormData;
    });
  };

  const handleTimeChange = (name, value) => {
    const rawDate = new Date(value);
    // Get hours, minutes, and seconds with padding
    const hours = String(rawDate.getHours()).padStart(2, "0");
    const minutes = String(rawDate.getMinutes()).padStart(2, "0");
    const seconds = String(rawDate.getSeconds()).padStart(2, "0");

    const timeString = `${hours}:${minutes}:${seconds}`;
    setFormData((prev) => {
      let updatedFormData = {
        ...prev,
        [name]: null,
      };
      if (name === "promotionStartTime") {
        updatedFormData.promotionStartTime = timeString;
      }
      if (name === "promotionEndTime") {
        updatedFormData.promotionEndTime = timeString;
      }
      return updatedFormData;
    });
    setErrors((prevErrors) => {
      let errorFormData = {
        ...prevErrors,
        [name]: null,
      };
      return errorFormData;
    });
  };

  // Convert 'YYYY-MM-DD' → Date object (local timezone-safe)
  const getLocalDateObject = (dateStr) => {
    if (!dateStr || typeof dateStr !== "string") return null;
    const [year, month, day] = dateStr.split("-").map(Number);
    return new Date(year, month - 1, day);
  };

  // Convert Date → 'YYYY-MM-DD'
  const getLocalDateStr = (date) => {
    if (!(date instanceof Date)) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Format for display → 'dd MMM yyyy'
  const formatDate = (dateStr) => {
    if (!dateStr || typeof dateStr !== "string" || !dateStr.includes("-"))
      return "";
    const [year, month, day] = dateStr.split("-");
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const monthIndex = parseInt(month, 10) - 1;
    if (monthIndex < 0 || monthIndex > 11 || !day || !year) return "";
    return `${day} ${months[monthIndex]} ${year}`;
  };

  // Formate time for display → 'XX:XX AM/PM'
  const formateTime = (timeStr) => {
    const [hour, minute] = timeStr.split(":");
    const h = parseInt(hour, 10);
    const m = parseInt(minute, 10);

    const ampm = h >= 12 ? "PM" : "AM";
    const hour12 = h % 12 === 0 ? 12 : h % 12;

    return `${String(hour12).padStart(2, "0")}:${String(m).padStart(
      2,
      "0",
    )} ${ampm}`;
  };

  const getEditPromotion = (promotionId) => {
    setIsLoading(true);
    let payload = { promoId: promotionId };
    delivaApiService("getPromo", payload)
      .then((response) => {
        if (response?.data?.status === 400) {
          showErrorToast(response?.data?.message);
        } else if (response?.data?.status === 200) {
          setEditData(response?.data?.resourceData);
        }
      })
      .catch(() => {
        showErrorToast("Failed to fetch promotion data.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const fetchInitialData = async () => {
    try {
      setIsLoading(true);
      const [
        getAllDeliveryRequestType,
        getPromoDiscountType,
        getUsageLimit,
        getUsagefrequency,
        getSelectOccasions,
        getUserCategory,
        getRecurringPromotions,
        getDeliveryDurationUnit,
      ] = await Promise.all([
        delivaApiService("getAllDeliveryRequestType"),
        delivaApiService("getPromoDiscountType"),
        delivaApiService("getUsageLimit"),
        delivaApiService("getUsagefrequency"),
        delivaApiService("getSelectOccasions"),
        delivaApiService("getUserCategory"),
        delivaApiService("getRecurringPromotions"),
        delivaApiService("getDeliveryDurationUnit"),
      ]);

      if (getAllDeliveryRequestType?.status === 200) {
        setDeleveryRequestType(getAllDeliveryRequestType.data?.resourceData);
      }
      if (getPromoDiscountType?.status === 200) {
        setSelectDiscountType(getPromoDiscountType.data?.resourceData);
      }

      if (getUsageLimit?.status === 200) {
        setUsageLimit(
          getUsageLimit.data?.resourceData?.map((item) => ({
            label: item?.id,
            value: item?.value,
          })),
        );
      }

      if (getUsagefrequency?.status === 200) {
        setUsageFrequency(getUsagefrequency.data?.resourceData);
      }

      if (getSelectOccasions?.status === 200) {
        setOccation(
          getSelectOccasions.data?.resourceData?.map((item) => ({
            label: item?.id,
            value: item?.value,
          })),
        );
      }

      if (getUserCategory?.status === 200) {
        setUserCategory(
          getUserCategory.data?.resourceData?.map((item) => ({
            label: item?.id,
            value: item?.value,
          })),
        );
      }

      if (getRecurringPromotions?.status === 200) {
        setRecPromotion(
          getRecurringPromotions.data?.resourceData?.map((item) => ({
            label: item?.id,
            value: item?.value,
          })),
        );
      }

      if (getDeliveryDurationUnit?.status === 200) {
        const options = getDeliveryDurationUnit.data?.resourceData
          ?.map((item) => ({
            label: item?.id?.trim(),
            value: item?.value,
          }))
          ?.sort((a, b) => a.label.localeCompare(b.label)); // optional sort

        setDurationUnit(options);
      }
    } catch (error) {
      showErrorToast("Failed to fetch initial form data.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formData.geolocationBasedPromotions && !isZipValid) {
      setZipError("Please enter a valid ZIP code for the selected country.");
      return;
    }

    const validationErrors = validation(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // Create payload similar to referral implementation - keep it simple
    const startUTC = getUTCDateAndTimeFromLocal(
      formData.promotionStartDate,
      formData.promotionStartTime,
    );
    const endUTC = getUTCDateAndTimeFromLocal(
      formData.promotionEndDate,
      formData.promotionEndTime,
    );
    const addPromoPayload = {
      code: formData.code.toUpperCase().trim(),
      roleId: Number(formData.roleId),
      offerName: formData.offerName,
      description: formData.description,
      deliveryRequestType: formData.deliveryRequestType,
      discountType: formData.discountType,
      discountAmount:
        formData.discountType === "FIXED_AMOUNT"
          ? formData.maxDiscountAmount
            ? parseFloat(formData.maxDiscountAmount)
            : null
          : null,
      percentageDiscount:
        formData.discountType === "PERCENTAGE_DISCOUNT" ||
        formData.discountType === "FREE_DELIVERY"
          ? formData.percentageDiscount
            ? parseFloat(formData.percentageDiscount)
            : 100
          : null,
      maxDiscountAmount:
        formData.discountType === "FIXED_AMOUNT"
          ? formData.maxDiscountAmount
            ? parseFloat(formData.maxDiscountAmount)
            : null
          : null,
      region: formData?.region,
      currency: formData?.currency,
      discountApplicationType: formData.discountApplication,
      promoDiscountType: formData.discountType,
      userCategory: formData.senderType,
      stackableDiscounts: formData.stackableDiscountsEnabled,
      promoId: 0,
      offerType: "PROMOTION",
      countOfUsageLimits: Number(formData.countOfUsageLimits) || null,
      usageFrequency: formData.usageFrequency,
      usageLimits: formData.usageLimits,
      minimumOrderAmount: Number(formData.minimumOrderAmount) || null,
      occasions: formData.occasions,
      recurringPromotions: formData.recurringPromotions,
      selectOccasions: formData.selectOccasions,
      otherOccasions: formData.otherOccasions || "",
      geolocationBasedPromotions: formData.geolocationBasedPromotions || null,
      noOfDelivery:
        formData.roleId === "3" ? Number(formData.noOfDelivery) : null,
      deliveryDuration:
        formData.roleId === "3" ? Number(formData.deliveryDuration) : null,

      imageUrl: "",
      promotionStartDate: startUTC?.date,
      promotionEndDate: endUTC?.date,
      promotionStartTime: startUTC?.time,
      promotionEndTime: endUTC?.time,
      details: formData.details || "",
      redeem: formData.redeem || "",
    };

    // === CLEAN EMPTY STRINGS TO NULL WHERE REQUIRED ===
    const sanitizeToNull = (value) => {
      return value === "" || value === undefined ? null : value;
    };

    addPromoPayload.recurringPromotions = sanitizeToNull(
      formData.recurringPromotions,
    );
    // addPromoPayload.usageLimits = sanitizeToNull(formData.usageLimits);
    addPromoPayload.usageFrequency = sanitizeToNull(formData.usageFrequency);
    addPromoPayload.occasions = sanitizeToNull(formData.occasions);
    addPromoPayload.selectOccasions = sanitizeToNull(formData.selectOccasions);
    addPromoPayload.setDurationUnit = sanitizeToNull(
      formData.deliveryDurationUnit,
    );

    if (formData.roleId === "2") {
      addPromoPayload.maxDiscountAmount =
        Number(formData.maxDiscountAmount) || null;
    }

    if (formData.roleId === "3") {
      addPromoPayload.deliveryDurationUnit = formData.deliveryDurationUnit;
    }

    const endPoint = formData.roleId === "3" ? "addPromo" : "addSenderPromo";

    console.log("Line 621 Add Promo Payload", addPromoPayload);
    setIsLoading(true);
    if (id && !isCopied) {
      // Edit mode
      const editPayload = { ...addPromoPayload, promoId: id };
      delivaApiService(endPoint, editPayload)
        .then((response) => {
          if (response?.data?.status === 400) {
            showErrorToast(response?.data?.message);
          } else if (response?.data?.status === 200) {
            showSuccessToast("Promotion Updated Successfully");
            setTimeout(() => {
              history.push({
                pathname: `/promotionReferralList`,
                state: { tab: "promotion" },
              });
            }, 500);
          }
        })
        .catch(() => {
          showErrorToast("Failed to update promotion.");
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      // Add or Copy mode
      const copyPayload = { ...addPromoPayload, promoId: 0 };
      delivaApiService(endPoint, copyPayload)
        .then((response) => {
          if (response?.data?.status === 400) {
            showErrorToast(response?.data?.message);
          } else if (response?.data?.status === 200) {
            !isCopied && showSuccessToast("New Promotion Added Successfully");
            isCopied && showSuccessToast("Promotion Copied Successfully");
            setTimeout(() => {
              history.push({
                pathname: `/promotionReferralList`,
                state: { tab: "promotion" },
              });
            }, 500);
            setFormData(initialFormData);
          }
        })
        .catch(() => {
          showErrorToast("Failed to add promotion.");
        })
        .finally(() => {
          setIsLoading(false);
        });
    }

    setErrors({});
  };

  useEffect(() => {
    fetchInitialData();
  }, []);

  useEffect(() => {
    if (id) {
      getEditPromotion(id);
    }
  }, [id]);

  useEffect(() => {
    if (editData && selectDiscountType.length > 0) {
      // Convert UTC date/time to local for form display
      let localStart = { date: "", time: "" };
      let localEnd = { date: "", time: "" };
      if (editData.promotionStartDate && editData.promotionStartTime) {
        localStart = getLocalDateAndTimeFromUTC(
          editData.promotionStartDate,
          editData.promotionStartTime,
        );
      }
      if (editData.promotionEndDate && editData.promotionEndTime) {
        localEnd = getLocalDateAndTimeFromUTC(
          editData.promotionEndDate,
          editData.promotionEndTime,
        );
      }

      setFormData((prevFormData) => {
        return {
          ...prevFormData,
          code: editData?.code ? editData?.code.toUpperCase().trim() : "",
          offerType: "PROMOTION",
          region: editData?.region,
          currency: editData?.currency,
          roleId:
            (editData?.userType === "customer" && "2") ||
            (editData?.userType === "delivery_agent" && "3") ||
            (editData?.roleId ? String(editData?.roleId) : ""),
          offerName: editData?.offerName || "",
          deliveryRequestType:
            editData?.deliveryRequestType || "LOCAL_DELIVERY",
          senderType: editData?.senderType || editData?.userCategory || null,
          discountType: editData?.promoDiscountType || null,
          usageLimits: editData?.usageLimits || null,
          usageFrequency: editData?.usageFrequency || null,
          discountAmount: editData?.discountAmount || "",
          maxDiscountAmount: editData?.maxDiscountAmount || "",
          percentageDiscount: editData?.percentageDiscount || "",
          discountApplication: editData?.discountApplicationType,
          stackableDiscountsEnabled: editData?.stackableDiscounts || false,
          countOfUsageLimits: editData?.countOfUsageLimits || "",
          minimumOrderAmount: editData?.minimumOrderAmount || null,
          occasions: editData?.occasions || null,
          recurringPromotions: editData?.recurringPromotions || null,
          otherOccasions: editData?.otherOccasions || "",
          geolocationBasedPromotions:
            editData?.geolocationBasedPromotions || "",
          noOfDelivery: editData?.noOfDelivery || "",
          deliveryDuration: editData?.deliveryDuration,
          deliveryDurationUnit: editData?.deliveryDurationUnit,
          imageUrl: editData?.imageUrl || "",
          promotionStartDate: localStart.date,
          promotionStartTime: localStart.time,
          promotionEndDate: localEnd.date,
          promotionEndTime: localEnd.time,
          description: editData?.description || "",
          details: editData?.details || "",
          redeem: editData?.redeem || "",
        };
      });
    }
  }, [editData, selectDiscountType, deleveryRequestType]);

  const isPreviewEnabled = () => {
    // Add only the fields that must be filled for preview
    const requiredFields =
      formData.roleId === "3"
        ? [
            "roleId",
            "offerName",
            "discountType",
            "region",
            "currency",
            "description",
            "promotionStartDate",
            "deliveryDuration",
            "noOfDelivery",
            "promotionStartTime",
            "usageFrequency",
            "code",
          ]
        : [
            "roleId",
            "offerName",
            "discountType",
            "region",
            "currency",
            "description",
            "promotionStartDate",
            "usageFrequency",
            "maxDiscountAmount",
            "promotionStartTime",
            "code",
          ];

    // If any field is empty/null, return false
    return requiredFields.every((field) => {
      const value = formData[field];
      return value !== null && value !== undefined && value !== "";
    });
  };

  const getCurrencyParts = (currencyString) => {
    const match = currencyString.match(/^(.+?)\s*\((.+?)\)$/);
    if (match) {
      return {
        name: match[1].trim(), // "Nigerian naira"
        symbol: match[2].trim(), // "₦"
      };
    }
    return {
      name: currencyString,
      symbol: "",
    };
  };

  // Inside your component render
  const currencyParts = getCurrencyParts(formData?.currency || "");

  return (
    <div className="page__wrapper h-100">
      <Header {...props} />
      <div className="mainContainer CustomerTable">
        <Row noGutters className="h-100">
          <Sidebar {...props} />
          <Col md={9} lg={10} className="boxTyp3">
            <div className="container-fluid">
              <div className="content-wrapper">
                <h3 className="font-weight-normal mb-0 line-ht color-33 fs-24">
                  {id && !isCopied ? "Edit" : isCopied ? "Copy" : "Add"}{" "}
                  Promotion
                </h3>
                <h5 className="font-weight-normal mb-0 line-ht color-head">
                  <span
                    className="pointer"
                    onClick={() =>
                      history.push({
                        pathname: `/promotionReferralList`,
                        state: { tab: "promotion" },
                      })
                    }
                  >
                    Promotion & Referral
                  </span>
                  <span className="icon-next mx-2 fs12"></span>
                  <span className="pointer">
                    {id && !isCopied ? "Edit" : isCopied ? "Copy" : "Add"}{" "}
                    Promotion
                  </span>
                </h5>
                <Card className="custom-card mt-4">
                  <Card.Body>
                    <Form onSubmit={handleSubmit} autoComplete="off">
                      <Row>
                        <Col lg={6}>
                          <SharedDropdown
                            label={
                              <>
                                User Type <span className="text-danger">*</span>
                              </>
                            }
                            name="roleId"
                            value={formData.roleId}
                            onChange={handleChange}
                            placeholder="Select User Type"
                            className="py-0"
                            disabled={isCopied}
                            error={errors.roleId}
                            options={[
                              { label: "Sender", value: "2" },
                              { label: "Delivery Partner", value: "3" },
                            ]}
                          />
                        </Col>

                        <Col lg={6}>
                          <Form.Group className="custom-form">
                            <Form.Label className="color-head">
                              Offer Type
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              as="select"
                              name="offerType"
                              className="py-0"
                              value={formData.offerType}
                              onChange={handleChange}
                              disabled
                            >
                              <option value="PROMOTION">Promotion</option>
                            </Form.Control>
                            {errors.offerType && (
                              <div className="text-danger">
                                {errors.offerType}
                              </div>
                            )}
                          </Form.Group>
                        </Col>
                        <Col lg={6}>
                          <Form.Group className="custom-form">
                            <Form.Label className="color-head">
                              Delivery Request Type
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              as="select"
                              name="deliveryRequestType"
                              className="py-0"
                              value={formData.deliveryRequestType}
                              onChange={handleChange}
                            >
                              <option value="">
                                Select Delivery Request Types
                              </option>
                              {Array.isArray(deleveryRequestType) &&
                              deleveryRequestType.length > 0 ? (
                                deleveryRequestType.map((item, index) => (
                                  <option key={index} value={item.value}>
                                    {item?.label}
                                  </option>
                                ))
                              ) : (
                                <option value="">
                                  Delivery Request Types Are Not Available
                                </option>
                              )}
                            </Form.Control>
                            {errors.deliveryRequestType && (
                              <div className="text-danger">
                                {errors.deliveryRequestType}
                              </div>
                            )}
                          </Form.Group>
                        </Col>

                        <Col lg={6}>
                          <SharedDropdown
                            label={
                              <>
                                {formData.roleId === "3"
                                  ? "Delivery Partner Type"
                                  : "Sender Type"}{" "}
                                <span className="text-danger">*</span>
                              </>
                            }
                            options={userCategory}
                            name="senderType"
                            value={formData.senderType ?? ""}
                            onChange={handleChange}
                            placeholder={
                              formData.roleId === "3"
                                ? "Select Delivery Partner Type"
                                : "Select Sender Type"
                            }
                            className="py-0"
                            error={errors.senderType}
                            required
                          />
                        </Col>

                        <Col lg={6}>
                          <Form.Group className="custom-form">
                            <Form.Label className="color-head">
                              Name Of Offer
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="offerName"
                              value={formData.offerName}
                              onChange={handleChange}
                              className="py-0"
                            />
                            {errors.offerName && (
                              <div className="text-danger">
                                {errors.offerName}
                              </div>
                            )}
                          </Form.Group>
                        </Col>
                        <Col lg={6}>
                          <Form.Group className="custom-form">
                            <Form.Label className="color-head">
                              Discount Type
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              as="select"
                              name="discountType"
                              className="py-0"
                              value={formData.discountType}
                              onChange={handleChange}
                              disabled={formData.roleId === "3"}
                            >
                              <option value="">Select Discount Type</option>
                              {Array.isArray(selectDiscountType) &&
                                selectDiscountType.length > 0 &&
                                (formData.roleId === "2"
                                  ? selectDiscountType
                                      .filter(
                                        (item) => item.value !== "FIXED_AMOUNT",
                                      )
                                      .map((item, index) => (
                                        <option key={index} value={item.value}>
                                          {item?.id}
                                        </option>
                                      ))
                                  : formData.roleId === "3"
                                    ? selectDiscountType.map((item, index) => (
                                        <option key={index} value={item.value}>
                                          {item?.id}
                                        </option>
                                      ))
                                    : selectDiscountType
                                        .filter(
                                          (item) =>
                                            item.value !== "FIXED_AMOUNT",
                                        )
                                        .map((item, index) => (
                                          <option
                                            key={index}
                                            value={item.value}
                                          >
                                            {item?.id}
                                          </option>
                                        )))}
                            </Form.Control>
                            {errors.discountType && (
                              <div className="text-danger">
                                {errors.discountType}
                              </div>
                            )}
                          </Form.Group>
                        </Col>
                        <Col lg={6}>
                          <Form.Group className="custom-form">
                            <Form.Label className="color-head">
                              {formData.discountType === "FREE_DELIVERY" ||
                              formData.discountType === "PERCENTAGE_DISCOUNT"
                                ? "Discount Percentage (%)"
                                : formData.discountType === "FIXED_AMOUNT"
                                  ? `Reward Amount${
                                      formData?.currencySymbol
                                        ? ` (${formData.currencySymbol})`
                                        : ""
                                    }`
                                  : "Discount Percentage (%)"}

                              <span className="text-danger">*</span>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip style={{ width: "347px" }}>
                                    The discount percentage is decided to create
                                    an offer amount.
                                  </Tooltip>
                                }
                              >
                                <img
                                  src={tooltip}
                                  alt="tooltip"
                                  className="tooltip-icon infoIcon ml-2 "
                                />
                              </OverlayTrigger>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name={
                                formData.discountType === "FIXED_AMOUNT"
                                  ? "maxDiscountAmount"
                                  : "percentageDiscount"
                              }
                              value={
                                formData.discountType === "FIXED_AMOUNT"
                                  ? formData.maxDiscountAmount
                                  : formData.discountType ===
                                      "PERCENTAGE_DISCOUNT"
                                    ? formData.percentageDiscount
                                    : formData.discountType === "FREE_DELIVERY"
                                      ? 100
                                      : ""
                              }
                              onChange={handleChange}
                              className="py-0"
                              inputMode="numeric"
                              maxLength={
                                formData.discountType === "FIXED_AMOUNT" ? 5 : 3
                              }
                              disabled={
                                formData.discountType === "FREE_DELIVERY"
                              }
                              onKeyDown={(e) => {
                                const allowedKeys = [
                                  "Backspace",
                                  "Tab",
                                  "ArrowLeft",
                                  "ArrowRight",
                                  "Delete",
                                ];
                                if (
                                  !/^[0-9]$/.test(e.key) &&
                                  !allowedKeys.includes(e.key)
                                ) {
                                  e.preventDefault();
                                }
                              }}
                            />

                            {formData.roleId === "3"
                              ? errors.maxDiscountAmount && (
                                  <div className="text-danger">
                                    {errors.maxDiscountAmount}
                                  </div>
                                )
                              : formData.discountType !== "PERCENTAGE_DISCOUNT"
                                ? errors.discountAmount && (
                                    <div className="text-danger">
                                      {errors.discountAmount}
                                    </div>
                                  )
                                : errors.percentageDiscount && (
                                    <div className="text-danger">
                                      {errors.percentageDiscount}
                                    </div>
                                  )}
                          </Form.Group>
                        </Col>

                        {formData.roleId === "3" && (
                          <>
                            <Col lg={6}>
                              <Form.Group className="custom-form">
                                <Form.Label className="color-head">
                                  No. of Delivery{" "}
                                  <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  type="number"
                                  name="noOfDelivery"
                                  value={formData.noOfDelivery}
                                  onChange={handleChange}
                                  className="py-0"
                                  min="1"
                                  maxLength="5"
                                  inputMode="numeric"
                                  onKeyDown={(e) => {
                                    const allowedKeys = [
                                      "Backspace",
                                      "Tab",
                                      "ArrowLeft",
                                      "ArrowRight",
                                      "Delete",
                                    ];
                                    if (
                                      !/^[0-9]$/.test(e.key) &&
                                      !allowedKeys.includes(e.key)
                                    ) {
                                      e.preventDefault();
                                    }
                                    // Prevent more than 5 digits
                                    if (
                                      e.target.value &&
                                      e.target.value.length >= 5 &&
                                      /^[0-9]$/.test(e.key)
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                                {errors.noOfDelivery && (
                                  <div className="text-danger">
                                    {errors.noOfDelivery}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                            <Col lg={6}>
                              <Form.Group className="custom-form">
                                <Form.Label className="color-head">
                                  Delivery duration{" "}
                                  <span className="text-danger">*</span>
                                </Form.Label>
                                <InputGroup>
                                  <Form.Control
                                    type="number"
                                    name="deliveryDuration"
                                    value={formData?.deliveryDuration}
                                    onChange={handleChange}
                                    className="py-0"
                                    min="1"
                                    maxLength="5"
                                    inputMode="numeric"
                                    style={{ borderRight: 0 }}
                                    onKeyDown={(e) => {
                                      const allowedKeys = [
                                        "Backspace",
                                        "Tab",
                                        "ArrowLeft",
                                        "ArrowRight",
                                        "Delete",
                                      ];
                                      if (
                                        !/^[0-9]$/.test(e.key) &&
                                        !allowedKeys.includes(e.key)
                                      ) {
                                        e.preventDefault();
                                      }
                                      // Prevent more than 5 digits
                                      if (
                                        e.target.value &&
                                        e.target.value.length >= 5 &&
                                        /^[0-9]$/.test(e.key)
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                  />

                                  <Form.Control
                                    as="select"
                                    name="deliveryDurationUnit"
                                    value={formData.deliveryDurationUnit}
                                    onChange={handleChange}
                                    className="py-0"
                                    style={{ maxWidth: 120, borderLeft: 0 }}
                                  >
                                    {durationUnit?.map((unit) => (
                                      <option
                                        key={"unit" + unit?.value}
                                        value={unit?.value}
                                      >
                                        {unit?.label}
                                      </option>
                                    ))}
                                  </Form.Control>
                                </InputGroup>
                                {errors.deliveryDuration && (
                                  <div className="text-danger">
                                    {errors.deliveryDuration}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                          </>
                        )}

                        {formData.roleId !== "3" && (
                          <Col lg={6}>
                            <Form.Group className="custom-form">
                              <Form.Label className="color-head">
                                Max. Amount of Discount (Upto)
                                <span className="text-danger">*</span>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="maxDiscountAmount"
                                value={formData.maxDiscountAmount}
                                onChange={handleChange}
                                className="py-0"
                                inputMode="numeric"
                                maxLength="5"
                                onKeyDown={(e) => {
                                  const allowedKeys = [
                                    "Backspace",
                                    "Tab",
                                    "ArrowLeft",
                                    "ArrowRight",
                                    "Delete",
                                  ];
                                  if (
                                    !/^[0-9]$/.test(e.key) &&
                                    !allowedKeys.includes(e.key)
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                              {errors.maxDiscountAmount && (
                                <div className="text-danger">
                                  {errors.maxDiscountAmount}
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                        )}

                        <Col lg={6}>
                          <SharedCountryDropdown
                            label={
                              <>
                                Country <span className="text-danger">*</span>
                              </>
                            }
                            selectedCountry={formData.region}
                            setSelectedCountry={(value) =>
                              setFormData((prev) => ({
                                ...prev,
                                region: value,
                              }))
                            }
                            onCountryChange={handleCountryChange}
                          />
                          {errors.region && (
                            <div
                              className="text-danger"
                              style={{ marginTop: "-23px" }}
                            >
                              {errors.region}
                            </div>
                          )}
                        </Col>

                        <Col lg={6}>
                          <SharedDropdown
                            label={
                              <>
                                Currency <span className="text-danger">*</span>
                              </>
                            }
                            name="currency"
                            value={formData.currency}
                            onChange={handleChange}
                            options={
                              formData.currency
                                ? [
                                    {
                                      label: formData.currency,
                                      value: formData.currency,
                                    },
                                  ]
                                : []
                            }
                            disabled={true}
                            placeholder="Select Currency"
                            className="currencySelect"
                          />
                          {errors.currency && (
                            <div
                              className="text-danger"
                              style={{ marginTop: "-23px" }}
                            >
                              {errors.currency}
                            </div>
                          )}
                        </Col>

                        <Col lg={12}>
                          <Form.Group className="custom-form">
                            <Form.Label className="color-head">
                              Description<span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              as="textarea"
                              rows="3"
                              name="description"
                              value={formData.description}
                              onChange={handleChange}
                              maxLength="100"
                              className="py-0"
                            />
                            {errors.description && (
                              <div className="text-danger">
                                {errors.description}
                              </div>
                            )}
                            <span className="min-char d-block">
                              Max 100 chars
                            </span>
                          </Form.Group>
                        </Col>
                        <Col lg={12}>
                          <Form.Group className="custom-form">
                            <Form.Label className="color-head">
                              Promo Details
                            </Form.Label>
                            <Form.Control
                              as="textarea"
                              rows="3"
                              name="details"
                              value={formData.details}
                              onChange={handleChange}
                              maxLength="501"
                              className="py-0"
                            />
                            {errors.details && (
                              <div className="text-danger">
                                {errors.details}
                              </div>
                            )}
                            <span className="min-char d-block">
                              Max 500 chars
                            </span>
                          </Form.Group>
                        </Col>
                        <Col lg={12}>
                          <Form.Group className="custom-form">
                            <Form.Label className="color-head">
                              How to Redeem
                            </Form.Label>
                            <Form.Control
                              as="textarea"
                              rows="3"
                              name="redeem"
                              value={formData.redeem}
                              onChange={handleChange}
                              maxLength="501"
                              className="py-0"
                            />
                            {errors.redeem && (
                              <div className="text-danger">{errors.redeem}</div>
                            )}
                            <span className="min-char d-block">
                              Max 500 chars
                            </span>
                          </Form.Group>
                        </Col>
                      </Row>
                      {/* Promotion Form Fields */}
                      <div className="promotion-fields">
                        <section
                          className="mb-4"
                          aria-label="Discount Restrictions"
                        >
                          <Row>
                            <Col lg={12} className="mb-4">
                              <h3 className="font-weight-normal mb-3 line-ht color-33 fs20">
                                Discount Application
                                <span className="text-danger">*</span>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip style={{ width: "347px" }}>
                                      A discount application is a way to use a
                                      discount by user
                                    </Tooltip>
                                  }
                                >
                                  <img
                                    src={tooltip}
                                    alt="tooltip"
                                    className="tooltip-icon infoIcon ml-2 "
                                  />
                                </OverlayTrigger>
                              </h3>

                              <Form.Group
                                className="d-flex mb-0"
                                style={{ gap: "30px" }}
                              >
                                <div className="checkboxContainer">
                                  <input
                                    id="atmApp"
                                    type="radio"
                                    name="discountApplication"
                                    value="AUTOMATIC_APPLICATION"
                                    checked={
                                      formData.discountApplication ===
                                      "AUTOMATIC_APPLICATION"
                                    }
                                    onChange={handleChange}
                                  />
                                  <label htmlFor="atmApp">
                                    {" "}
                                    Automatic Application
                                  </label>
                                </div>
                                <div className="pl-2  ml-2 border-left"></div>
                                <div className="checkboxContainer mr-4">
                                  <input
                                    id="manual"
                                    type="radio"
                                    name="discountApplication"
                                    value="MANUAL_ENTRY"
                                    checked={
                                      formData.discountApplication ===
                                      "MANUAL_ENTRY"
                                    }
                                    onChange={handleChange}
                                  />
                                  <label htmlFor="manual"> Manual Entry</label>
                                </div>
                                {formData?.roleId != "3" &&
                                  formData.discountApplication ===
                                    "MANUAL_ENTRY" && (
                                    <div className="checkboxContainer">
                                      <input
                                        id="stack"
                                        type="checkbox"
                                        name="stackableDiscountsEnabled"
                                        checked={
                                          formData.stackableDiscountsEnabled
                                        }
                                        onChange={handleChange}
                                      />
                                      <label htmlFor="stack">
                                        Stackable Discounts
                                      </label>
                                    </div>
                                  )}
                              </Form.Group>
                              {errors.discountApplication && (
                                <div className="text-danger">
                                  {errors.discountApplication}
                                </div>
                              )}
                            </Col>
                            <Col lg={6}>
                              <Form.Group className="custom-form">
                                <Form.Label className="color-head">
                                  Code<span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="code"
                                  value={formData.code}
                                  onChange={handleChange}
                                  className="py-0 text-uppercase"
                                />
                                {errors.code && (
                                  <div className="text-danger">
                                    {errors.code}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                          </Row>
                        </section>
                        <section
                          className="mb-4"
                          aria-label="Discount Restrictions"
                        >
                          <Row>
                            <Col lg={12}>
                              <h3 className="font-weight-normal mb-3 line-ht color-33 fs20">
                                Discount Restrictions
                              </h3>
                            </Col>
                            <Col lg={6}>
                              <Form.Group className="custom-form">
                                <Form.Label className="color-head">
                                  Minimum Order Amount
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="minimumOrderAmount"
                                  value={formData.minimumOrderAmount}
                                  onChange={handleChange}
                                  maxLength="5"
                                  className="py-0 text-uppercase"
                                />
                                {errors.minimumOrderAmount && (
                                  <div className="text-danger">
                                    {errors.minimumOrderAmount}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>

                            <Col lg={6}>
                              <SharedDropdown
                                label={
                                  <>
                                    Usage Limits{" "}
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip style={{ width: "347px" }}>
                                          Usage limits decide the use of the
                                          offer for the user
                                        </Tooltip>
                                      }
                                    >
                                      <img
                                        src={tooltip}
                                        alt="tooltip"
                                        className="tooltip-icon infoIcon ml-1 "
                                      />
                                    </OverlayTrigger>
                                  </>
                                }
                                options={usageLimit}
                                name="usageLimits"
                                value={formData.usageLimits ?? ""}
                                onChange={handleChange}
                                placeholder="Select Usage Limits"
                                className="py-0"
                                error={errors.usageLimits}
                              />
                            </Col>
                            <Col lg={6}>
                              <Form.Group className="custom-form">
                                <Form.Label className="color-head">
                                  Count of usage limits (
                                  {formData.usageLimits === "PER_SENDER"
                                    ? "Per Sender"
                                    : formData.usageLimits === "OVERALL"
                                      ? "overall"
                                      : "Per Sender"}
                                  )
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="countOfUsageLimits"
                                  value={formData.countOfUsageLimits}
                                  onChange={handleChange}
                                  maxLength="5"
                                  className="py-0 text-uppercase"
                                />
                                {errors.countOfUsageLimits && (
                                  <div className="text-danger">
                                    {errors.countOfUsageLimits}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                          </Row>
                        </section>
                        <section
                          className="mb-4"
                          aria-label="Promotion Dates and Time"
                        >
                          <Row>
                            <Col lg={12}>
                              <h3 className="font-weight-normal mb-3 line-ht color-33 fs20">
                                Promotion Dates and Time
                              </h3>
                            </Col>
                            <Col lg={6}>
                              <Form.Group className="custom-form d-flex flex-column">
                                <Form.Label className="color-head ">
                                  Start Date{" "}
                                  <span className="text-danger">*</span>
                                </Form.Label>
                                <DatePicker
                                  autoComplete="off"
                                  placeholderText="Select date"
                                  showTimeCaption={false}
                                  selected={
                                    formData.promotionStartDate
                                      ? getLocalDateObject(
                                          formData.promotionStartDate,
                                        )
                                      : null
                                  }
                                  minDate={new Date()}
                                  dateFormat="dd MMM yyyy"
                                  name="promotionStartDate"
                                  onFocus={(e) => e.target.blur()}
                                  value={
                                    formData.promotionStartDate
                                      ? formatDate(formData.promotionStartDate)
                                      : ""
                                  }
                                  onChange={(date) => {
                                    setStartDate(date);
                                    handleDateChange(
                                      "promotionStartDate",
                                      getLocalDateStr(date),
                                    );
                                  }}
                                />
                                {errors.promotionStartDate && (
                                  <div className="text-danger">
                                    {errors.promotionStartDate}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                            <Col lg={6}>
                              <Form.Group className="custom-form d-flex flex-column">
                                <Form.Label className="color-head">
                                  End Date
                                </Form.Label>
                                <DatePicker
                                  autoComplete="off"
                                  placeholderText="Select date"
                                  showTimeCaption={false}
                                  selected={
                                    formData.promotionEndDate
                                      ? getLocalDateObject(
                                          formData.promotionEndDate,
                                        )
                                      : null
                                  }
                                  minDate={startDate}
                                  dateFormat="dd MMM yyyy"
                                  name="promotionEndDate"
                                  onFocus={(e) => e.target.blur()}
                                  value={
                                    formData.promotionEndDate
                                      ? formatDate(formData.promotionEndDate)
                                      : ""
                                  }
                                  onChange={(date) => {
                                    setEndDate(date);
                                    handleDateChange(
                                      "promotionEndDate",
                                      getLocalDateStr(date),
                                    );
                                  }}
                                />
                              </Form.Group>
                            </Col>

                            <Col lg={6}>
                              <Form.Group className="custom-form time-wrapper d-flex flex-column">
                                <Form.Label className="color-head ">
                                  Start Time
                                  <span className="text-danger">*</span>
                                </Form.Label>
                                <DatePicker
                                  autoComplete="off"
                                  placeholderText="Select time"
                                  showTimeCaption={false}
                                  selected={startTime}
                                  showTimeSelect
                                  showTimeSelectOnly
                                  timeIntervals={1}
                                  onFocus={(e) => e.target.blur()}
                                  timeCaption="Time"
                                  dateFormat="h:mm aa"
                                  name="promotionStartTime"
                                  value={
                                    formData.promotionStartTime
                                      ? formateTime(formData.promotionStartTime)
                                      : ""
                                  }
                                  minTime={minStartTime}
                                  maxTime={new Date().setHours(23, 59, 59, 999)}
                                  onChange={(time) => {
                                    setStartTime(time);
                                    handleTimeChange(
                                      "promotionStartTime",
                                      time,
                                    );
                                  }}
                                />
                                {errors.promotionStartTime && (
                                  <div className="text-danger">
                                    {errors.promotionStartTime}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>

                            <Col lg={6}>
                              <Form.Group className="custom-form time-wrapper d-flex flex-column">
                                <Form.Label className="color-head">
                                  End Time
                                </Form.Label>
                                <DatePicker
                                  autoComplete="off"
                                  placeholderText="Select time"
                                  showTimeCaption={false}
                                  selected={endTime}
                                  showTimeSelect
                                  showTimeSelectOnly
                                  timeIntervals={1}
                                  onFocus={(e) => e.target.blur()}
                                  timeCaption="Time"
                                  dateFormat="h:mm aa"
                                  name="promotionEndTime"
                                  value={
                                    formData.promotionEndTime
                                      ? formateTime(formData.promotionEndTime)
                                      : ""
                                  }
                                  minTime={minEndTime}
                                  maxTime={new Date().setHours(23, 59, 59, 999)}
                                  onChange={(time) => {
                                    setEndTime(time);
                                    handleTimeChange("promotionEndTime", time);
                                  }}
                                />
                                {errors.promotionEndTime && (
                                  <div className="text-danger">
                                    {errors.promotionEndTime}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>

                            <Col lg={6}>
                              <SharedDropdown
                                label={
                                  <>
                                    Recurring Promotions{" "}
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip style={{ width: "347px" }}>
                                          Recurring promotion helps to repeat
                                          the same offer for a weekly or monthly
                                        </Tooltip>
                                      }
                                    >
                                      <img
                                        src={tooltip}
                                        alt="tooltip"
                                        className="tooltip-icon infoIcon ml-1 "
                                      />
                                    </OverlayTrigger>
                                  </>
                                }
                                options={recPromotion}
                                name="recurringPromotions"
                                value={formData.recurringPromotions ?? ""}
                                onChange={handleChange}
                                placeholder="Select Recurring Promotions"
                                className="py-0"
                                error={errors.recurringPromotions}
                              />
                            </Col>
                            <Col lg={6}>
                              <Form.Group className="custom-form">
                                <Form.Label className="color-head">
                                  Usage Frequency{" "}
                                  <span className="text-danger">*</span>
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip style={{ width: "347px" }}>
                                        Usage frequency helps to use the offer
                                        within a particular time duration.
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      src={tooltip}
                                      alt="tooltip"
                                      className="tooltip-icon infoIcon ml-2 "
                                    />
                                  </OverlayTrigger>
                                </Form.Label>
                                <Form.Control
                                  as="select"
                                  name="usageFrequency"
                                  className="py-0"
                                  value={formData.usageFrequency}
                                  onChange={handleChange}
                                >
                                  <option value="">
                                    Select Usage Frequency
                                  </option>

                                  {Array.isArray(usageFrequency) &&
                                  usageFrequency.length > 0 ? (
                                    usageFrequency
                                      .filter((item) => {
                                        if (
                                          formData.recurringPromotions ===
                                          "EVERY_WEEKEND"
                                        ) {
                                          return (
                                            item.id === "Once every 5 days" ||
                                            item.id === "Every time"
                                          );
                                        }
                                        return true;
                                      })
                                      .map((item, index) => (
                                        <option key={index} value={item.value}>
                                          {item?.id}
                                        </option>
                                      ))
                                  ) : (
                                    <option value="">
                                      Usage Frequencies Are Not Available
                                    </option>
                                  )}
                                </Form.Control>
                                {errors.usageFrequency && (
                                  <div className="text-danger">
                                    {errors.usageFrequency}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                          </Row>
                        </section>
                        <section
                          className="mb-4"
                          aria-label="Special Conditions"
                        >
                          <Row>
                            <Col lg={12}>
                              <h3 className="font-weight-normal mb-3 line-ht color-33 fs20">
                                Special Conditions
                              </h3>
                            </Col>
                            <Col lg={6}>
                              <Form.Group className="custom-form">
                                <Form.Label className="color-head">
                                  Geolocation-Based Promotions
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip style={{ width: "347px" }}>
                                        Geolocation helps to apply the offer in
                                        a particular locations
                                      </Tooltip>
                                    }
                                  >
                                    <img
                                      src={tooltip}
                                      alt="tooltip"
                                      className="tooltip-icon infoIcon ml-2 "
                                    />
                                  </OverlayTrigger>
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="geolocationBasedPromotions"
                                  value={formData.geolocationBasedPromotions}
                                  onChange={handleZipInputChange}
                                  className="py-0"
                                  maxLength={6}
                                  autoComplete="off"
                                  disabled={zipLoading}
                                />
                                {zipSuggestions.length > 0 && (
                                  <ul className="location-suggestions">
                                    {zipSuggestions.map((option) => (
                                      <li
                                        key={option.value}
                                        className="location-suggestion-item"
                                        onClick={() =>
                                          handleZipSelectDropdown(option)
                                        }
                                      >
                                        {option.label}
                                      </li>
                                    ))}
                                  </ul>
                                )}
                                {zipError && (
                                  <div className="text-danger">{zipError}</div>
                                )}
                              </Form.Group>
                            </Col>

                            <Col lg={6}>
                              <SharedDropdown
                                label="Occasion"
                                options={occation}
                                name="occasions"
                                value={formData.occasions ?? ""}
                                onChange={handleChange}
                                placeholder="Select Occasion"
                                className="py-0"
                                error={errors.occasions}
                              />
                            </Col>

                            {formData.occasions === "OTHER" && (
                              <Col lg={6}>
                                <Form.Group className="custom-form">
                                  <Form.Label className="color-head">
                                    Please enter other occasion name
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="otherOccasions"
                                    value={formData.otherOccasions}
                                    onChange={handleChange}
                                    className="py-0"
                                    disabled={formData.occasions !== "OTHER"}
                                  />
                                  {errors.otherOccasions && (
                                    <div className="text-danger">
                                      {errors.otherOccasions}
                                    </div>
                                  )}
                                </Form.Group>
                              </Col>
                            )}
                          </Row>
                        </section>
                      </div>

                      <Row>
                        <Col lg={12} className="mt-4">
                          <button
                            className="btnDefault btnOutline minw-150"
                            type="button"
                            onClick={() =>
                              history.push({
                                pathname: `/promotionReferralList`,
                                state: { tab: "promotion" },
                              })
                            }
                          >
                            Cancel
                          </button>
                          <button
                            className="btnDefault btnWarning minw-150 ml-3"
                            type="button"
                            onClick={() => setShowPreview(true)}
                            style={{
                              border: "1px solid #085133",
                              background: "transparent",
                              color: "#085133",
                            }}
                            disabled={!isPreviewEnabled() || errors.offerName}
                          >
                            Preview
                          </button>

                          <button
                            className="btnDefault btnPrimary minw-150 ml-3"
                            type="submit"
                          >
                            {id && !isCopied
                              ? "Update"
                              : isCopied
                                ? "Copy"
                                : "Add"}
                          </button>
                        </Col>
                      </Row>
                    </Form>
                  </Card.Body>
                </Card>
              </div>
            </div>
            <Footer {...props} />

            <Modal
              show={showPreview}
              onHide={() => setShowPreview(false)}
              centered
              size="md"
              className="customPreviewPopup"
            >
              <Modal.Body className="p-4">
                <img
                  src={crossLight}
                  alt="Close Icon"
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    width: "40px",
                    height: "40px",
                    zIndex: 2,
                    cursor: "pointer",
                  }}
                  onClick={() => setShowPreview(false)} // Optional: makes it close the modal
                />
                <div className="text-center font-weight-bold previewHeading previewTopHeadingSpace">
                  {formData?.roleId === "2"
                    ? "Preview Sender"
                    : "Preview Delivery Partner"}
                </div>

                <div
                  className="position-relative overflow-hidden"
                  style={{
                    borderRadius: "20px",
                    padding: "20px",
                    backgroundColor: "#000", // fallback in case image fails
                  }}
                >
                  {/* Background Image */}
                  <img
                    src={formData?.roleId === "2" ? previewSenderBg : previewBg}
                    alt="Preview Background"
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "20px",
                      zIndex: 0,
                    }}
                  />

                  {/* Cross Image at Top Right of Banner */}

                  {/* Overlay content */}
                  <div
                    className="position-relative text-white"
                    style={{ zIndex: 1 }}
                  >
                    {/* Content */}
                    <div className="d-flex justify-content-center flex-column align-items-center PrviewbuttonInnerBox">
                      <div
                        className={`text-center font-weight-bold mb-1 mt-2 text-uppercase previewHeading ${
                          formData.roleId === "2"
                            ? "text-white"
                            : "tertiary-color"
                        }`}
                      >
                        {errors.offerName ? "Offer Name" : formData?.offerName}
                      </div>
                      <div
                        className={`text-center mb-2 text-uppercase fw500 ${
                          formData.roleId === "2"
                            ? "text-white"
                            : "tertiary-color"
                        }`}
                      >
                        Special Offer Earn
                      </div>

                      <h3
                        className={`font-weight-bold mt-2 mb-2 ${
                          formData.roleId === "2"
                            ? "secondary-color"
                            : "primary-color-new"
                        }`}
                        style={{ fontSize: "50px" }}
                      >
                        {formData.discountType === "PERCENTAGE_DISCOUNT" ||
                        formData.discountType === "FREE_DELIVERY" ? (
                          <>
                            {formData.discountType === "PERCENTAGE_DISCOUNT"
                              ? formData.percentageDiscount
                              : 100}
                            %
                          </>
                        ) : (
                          <>
                            {currencyParts?.symbol}
                            {formData.maxDiscountAmount}
                          </>
                        )}
                      </h3>

                      <div className="mb-4 tertiary-color ">
                        {formData.roleId === "2" ? (
                          <div
                            className="text-uppercase  fw500 text-white"
                            style={{ fontSize: "32px" }}
                          >
                            off
                          </div>
                        ) : formData.discountType === "FREE_DELIVERY" ||
                          formData.discountType === "PERCENTAGE_DISCOUNT" ? (
                          "Discount Percentage (%)"
                        ) : formData.discountType === "FIXED_AMOUNT" ? (
                          `Reward Amount${
                            formData?.currencySymbol
                              ? ` (${formData.currencySymbol})`
                              : ""
                          }`
                        ) : (
                          "Discount Percentage (%)"
                        )}
                      </div>

                      <div className="bg-preview-dark text-white r px-3 py-1 small d-flex justify-content-center align-items-center w-100 mb-3 previewDataBox">
                        {formData.promotionStartDate
                          ? moment(formData.promotionStartDate).format(
                              "D MMM YYYY",
                            )
                          : moment().format("D MMM YYYY")}{" "}
                        –{" "}
                        {formData.promotionEndDate
                          ? moment(formData.promotionEndDate).format(
                              "D MMM YYYY",
                            )
                          : "Ongoing"}
                      </div>

                      <div
                        className="bg-preview-dark text-white p-2 small text-left mb-3 w-100"
                        style={{
                          minHeight: "100px",
                          maxHeight: "100px",
                          overflowY: "auto", // Only show scrollbar when needed
                        }}
                      >
                        <ul
                          className="pl-0 mb-1"
                          style={{
                            listStyle: "none",
                            paddingLeft: 0,
                            marginBottom: 0,
                          }}
                        >
                          <li className="fs16 fw500 mb-1 d-flex">
                            <span>
                              <img
                                className="mr-2"
                                src={SealCheckRounded}
                                alt="SealCheckRounded"
                                style={{ marginTop: -2 }}
                              />
                            </span>
                            <div>{formData?.description}</div>
                          </li>
                        </ul>
                      </div>

                      <div
                        className={`small ${
                          formData.roleId === "2"
                            ? "text-white"
                            : "tertiary-color"
                        }`}
                        style={{ alignSelf: "start" }}
                      >
                        Coupon code
                      </div>
                      <div className="bg-preview-dark text-white font-weight-bold p-2 mt-1 mb-2 d-inline-block w-100 text-center">
                        {formData.code || "SUMERSK"}
                      </div>
                      {formData.discountApplication ===
                      "AUTOMATIC_APPLICATION" ? (
                        <div className="small automaticOffer tertiary-color mt-2 fs16 fw500 text-uppercase">
                          *Offer automatically apply
                        </div>
                      ) : (
                        <div className="small mt-2 fs16 fw500 text-uppercase copyPreviewBtnBox">
                          {formData?.roleId === "2" ? (
                            <Button className="previewCopyBtn primary-color-new fw-bold text-uppercase">
                              Copy
                            </Button>
                          ) : (
                            <Button
                              className="previewCopyBtn primary-color-new bg-preview-dark fw-bold text-uppercase w-100"
                              style={{ color: "#ffffff", borderRadius: "30px" }}
                            >
                              Participate
                            </Button>
                          )}
                        </div>
                      )}

                      <div
                        className={`small text-underline mt-2 ${
                          formData?.roleId === "2"
                            ? "text-white"
                            : "tertiary-color"
                        }`}
                      >
                        Terms & Conditions
                      </div>

                      <Button
                        variant="link"
                        onClick={() => setShowPreview(false)}
                        className={`font-weight-bold text-underline mt-2 closeBtnDark p-0 ${
                          formData.roleId === "2"
                            ? "text-white"
                            : "tertiary-color"
                        }`}
                      >
                        CLOSE
                      </Button>
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </Col>
        </Row>
        <Loader showLoader={isLoading} />
      </div>
    </div>
  );
};

export default CreatePromotion;
